var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flat-pickr',{staticClass:"msi-date-select msi-date-select-sm",attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"config":_vm.config},on:{"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }